// @flow
import React, { type Node } from 'react';

import PlainIcon, { iconTypes } from 'app/common/ui-next/plain-icon';
import PlainButtonAsLink from 'app/common/ui-next/plain-button-as-link';

import styles from './MarksThemeSwitcher.scss';


type Props = {
  label: string,
  switchToBW: () => void,
  switchToColor: () => void,
}

const MarksThemeSwitcher = ({ label, switchToBW, switchToColor }: Props): Node => {
  return (
    <div className={styles.root}>
      <span>{`${label}:`}</span>

      <PlainButtonAsLink onClick={switchToBW}>
        <PlainIcon
          type={iconTypes.THEME_BW}
          width={20}
          height="auto"
        />
      </PlainButtonAsLink>

      <PlainButtonAsLink onClick={switchToColor}>
        <PlainIcon
          type={iconTypes.THEME_COLOR}
          width={20}
          height="auto"
        />
      </PlainButtonAsLink>
    </div>
  );
};

export default MarksThemeSwitcher;
